/** @jsxImportSource @emotion/react */

import { Input } from "reactstrap";
import usePatchLayer from "../../../../hooks/usePatchLayer";

import { useRouteLayer } from "../../../../hooks/useCurrentEntities";

export default function LayerNotes() {
    const patchLayer = usePatchLayer();
    const layer = useRouteLayer();

    return <>
        <h3 className="mb-0">NOTES</h3>

        <div className="pt-3" >
            <Input
                value={layer.arrival_feedback}
                type="textarea"
                id="latest_check_feedback"
                rows={4}
                maxLength={255}
                className="p-4"
                onChange={(e) => patchLayer(layer, "arrival_feedback", e.target.value)}
            />
        </div>

    </>;
}
